import React from 'react';
import ReactDOM from 'react-dom';

import NewSessisonPanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const createNewSessiosScreen = ({ referrerLink }) => {
  const domId = 'newSessionPanel';
  if (isSupportedBrowser()) {
    ReactDOM.render(
      <AuthScreenLayout>
        <NewSessisonPanel referrerLink={referrerLink} />
      </AuthScreenLayout>,
      document.getElementById(domId)
    );
  } else {
    ReactDOM.render(<UnsupportedBrowsers />, document.getElementById(domId));
  }
};

window.createNewSessiosScreen = createNewSessiosScreen;
